'use strict';

module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: require('./block-elements.json')
};



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/defaults.js
// module id = 74
// module chunks = 35783957827783 110308036455227 213720915766396